import { useEffect, useState } from 'react'
import { Card, Col, FloatingLabel, Form, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import PatientUserInfo from './PatientUserlInfo';
import PatientCourseQuestions from './PatientCourseQuestions';
import PatientGeneralClinicInfo from './PatientGeneralClinicInfo';
import PatientAppointments from './PatientAppointments';
import { GetUserByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Users/models/userModels';
import { getUserByUserId } from '../../../../Adaptor/TUBSIS';
import moment from 'moment';

// type Props = {userId: number}

const PatientDetail = /*React.FC<Props> = ({ userId })*/ () => {

    const { userId } = useParams();

    const [userData, setUserData] = useState<GetUserByIdOutput | null>(null)

    useEffect(() => {
        //console.log("uid", userId)
        if (userId && parseInt(userId) > 0) {

            getUserByUserId(parseInt(userId ?? "-1"))
                .then((response) => {

                    if (response && response.data !== null) {
                        setUserData(response.data)
                    }
                    // console.log("userData", response.data)
                })
                .catch((error) => {
                    console.error("Error fetching user:", error);
                });
        }
    }, [userId]);

    return (
        <>
            <Card>
                <Card.Header>
                    <Row className="mt-3">
                        <Form.Group as={Col}>
                            <FloatingLabel controlId="fullname" label="Ad Soyad">
                                <Form.Control
                                    type="text"
                                    name='fullname'
                                    style={{ border: "none" }}
                                    value={userData?.fullName}
                                    readOnly
                                />
                            </FloatingLabel>
                        </Form.Group>
                    </Row>
                    <Row className="mt-3">
                        <Form.Group as={Col}>
                            <FloatingLabel controlId="citizienId" label="T.C. Kimlik No">
                                <Form.Control
                                    type="text"
                                    name='citizienId'
                                    style={{ border: "none" }}
                                    value={userData?.citizenId}
                                    readOnly
                                />
                            </FloatingLabel>
                        </Form.Group>
                    </Row>
                    <Row className="mt-3">
                        <Form.Group as={Col}>
                            <FloatingLabel controlId="mobilePhone" label="Telefon Numarası">
                                <Form.Control
                                    type="text"
                                    name='mobilePhone'
                                    style={{ border: "none" }}
                                    value={userData?.mobilePhones}
                                    readOnly
                                />
                            </FloatingLabel>
                        </Form.Group>
                    </Row>
                    <Row className='mt-3'>
                        <Form.Group as={Col}>
                            <FloatingLabel controlId="birthDate" label="Doğum Tarihi">
                                <Form.Control
                                    type="text"
                                    name='birthDate'
                                    style={{ border: "none" }}
                                    value={moment(userData?.birthDate).format('DD MMMM YYYY')}
                                    readOnly
                                />
                            </FloatingLabel>
                        </Form.Group>
                    </Row>
                    <Row className='mt-3'>
                        <Form.Group as={Col}>
                            <FloatingLabel controlId='group' label="Program">
                                <Form.Control
                                    type="text"
                                    style={{ border: "none" }}
                                    name="group"
                                    value={userData?.groupId === 1 ? "TÜBSİS" : (userData?.groupId === 2 ? "POLSİS" : "SBP")}
                                    readOnly
                                />
                            </FloatingLabel>
                        </Form.Group>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <div className=''>
                        <PatientUserInfo userData={userData} />
                        <PatientGeneralClinicInfo userId={userData?.userId ?? -1} />
                        <PatientCourseQuestions userId={userData?.userId ?? -1} />
                    </div>
                    <div className='mt-3'>
                        <PatientAppointments userId={userData?.userId ?? -1} />
                    </div>
                </Card.Body>
            </Card>
        </>
    )

}

export default (PatientDetail)